import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24ffbf5c")

_pushScopeId("data-v-24ffbf5c")
const _hoisted_1 = { class: "login-form-wrapper grid-content p-15 p-lg-20 mx-auto" }
const _hoisted_2 = { class: "mb-13" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-5" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "session-duration" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fs-3 bi bi-lock" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = { class: "session-duration" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fs-3 bi bi-clock-history" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = { class: "text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "position-relative" }, {
      default: _withId(() => [
        _createVNode(_component_InnerLoader, {
          loading: _ctx.loading,
          innerLoading: true
        }, null, 8, ["loading"]),
        _createVNode(_component_el_main, null, {
          default: _withId(() => [
            _createVNode(_component_el_form, {
              rules: _ctx.rules,
              model: _ctx.loginData,
              ref: "loginForm"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_2, [
                  _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("message.WELCOME_BACK")), 1),
                  _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("message.SIGN_IN_TO_YOUR_ACCOUNT")), 1),
                  (_ctx.session_div)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _hoisted_6,
                        _createVNode("p", _hoisted_7, [
                          _hoisted_8,
                          _hoisted_9,
                          _createVNode("strong", null, _toDisplayString(_ctx.$t("message.LOGIN_DATE")) + ":", 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.login_date), 1)
                        ]),
                        _createVNode("p", _hoisted_10, [
                          _hoisted_11,
                          _hoisted_12,
                          _createVNode("strong", null, _toDisplayString(_ctx.$t("message.LAST_SESSION_DURATION")) + ":", 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.session_duration), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("a", {
                    href: _ctx.sso_url,
                    type: "button",
                    class: "btn btn-lg btn-primary w-100 mb-5"
                  }, _toDisplayString(_ctx.$t("message.LOGIN_TO_CONTINUE")), 9, ["href"])
                ])
              ]),
              _: 1
            }, 8, ["rules", "model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})